module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrows-angle-expand-367ca406.svg";